<form novalidate [formGroup]="_form" (keydown.enter)="$event.preventDefault()" class="form_style">

  <div class="row">
    <div class="col-12">
      <div class="transaction-section-header">
        <div class="transaction-section-header-title">Breakdown</div>
        <div class="transaction-section-header-actions header-actions">
          <button class="hidden-xs asap-btn" kendoButton (click)="_onSave($event)">
            <span><img [src]="'/assets/menu/'+ _theme +'/proccess-icon.svg'" /></span>Process
          </button>
          <button class="hidden-xs asap-btn" kendoButton (click)="_onClear()">
            <span><img [src]="'/assets/menu/'+ _theme +'/clear-icon.svg'" /></span>Clear
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="row no-row-margin">
    <div class="col-12 col-lg-6 small-pad-right">
      <div [ngClass]="isGeneralInformationExpanded == true ? 'transactionWidget' : 'transactionWidget-collapse'">
        <div class="row">
          <!-- <div class="col-12">
          <p class="titleStandardStyle">General Information</p>
        </div> -->

        <div class="col-12 sectionheader">
          <span class="titleStandardStyle">General Information</span>
          <span [ngClass]="isGeneralInformationExpanded == true ? 'k-icon k-i-sort-asc-sm' :  'k-icon k-i-sort-desc-sm'"
            class="float-right pointer-click"
          (click)="ExpandCollapseGeneralInfoWidget(isGeneralInformationExpanded)"></span>
        </div>
        @if (isGeneralInformationExpanded) {
          <div class="col-12 margin-top-10">
            <div class="form-group special_style_formgroup">
              <div class="row">
                <div class="col-2"><label class="control-label">Date - Time</label></div>
                <div class="col-10 transaction-input-fields">
                  <kendo-datetimepicker formControlName="date"
                    class="newFormControlWidth"
                    placeholder="Set Date and Time"
                    [attr.disabled]="_dateEnabled ? null : 'disabled'"
                    [format]="_datePickerFormat">
                  </kendo-datetimepicker>
                </div>
              </div>
              <div class="transactions-stock-right-checkbox empty-small"></div>
            </div>
          </div>
          @if (_currentUser && _currentUser.isEnterprise) {
            <div class="col-12">
              <div class="form-group special_style_formgroup">
                <div class="row">
                  <div class="col-2"><label class="control-label">Account</label></div>
                  <div class="col-10 transaction--input-fields">
                    <accounts-dropdown #kendo_combo_accounts
                      [formControl]="_selectedAccount"
                      class="bordered current-step newFormControlWidth"
                      [class.active]="_selectedAccount.value == null"
                      [required]="true">
                    </accounts-dropdown>
                  </div>
                </div>
                <div class="transaction--stock-right-checkbox empty-small"></div>
              </div>
            </div>
          }
          <sites-dropdown #kendo_combo_sites
            layout="transaction"
            [showAllSites]="true"
            [labelText]="'Site'"
            [inputContainerClass]="'transaction--input-fields'"
            formControlName="site"
            (siteChanged)="_onSiteChanged($event)"
            [placeholder]="'Choose a Site'"
            [textField]="'name'"
            [valueField]="'id'"
            class="bordered current-step newFormControlWidth"
            [required]="true">
          </sites-dropdown>
          <div class="col-12">
            <div class="form-group special_style_formgroup">
              <div class="row">
                <div class="col-2"><label class="control-label">Breakdown Inventory</label></div>
                <div class="col-10 transaction-input-fields">
                  <kendo-combobox #kendo_combo_breakdown_inventory
                    [data]="_breakdownInventoriesFiltered"
                    [filterable]="true"
                    (filterChange)="_handleBreakdownInventoriesFilter($event)"
                    (valueChange)="_handleBreakdownInventoryChange($event)"
                    [suggest]="true"
                    [placeholder]="'Choose an Inventory'"
                    [textField]="'inventoryNumber'"
                    [valueField]="'id'"
                    [formControl]="_selectedBreakdownInventory"
                    class="bordered newFormControlWidth" required>
                    <ng-template kendoComboBoxItemTemplate let-dataItem>
                      <div class="transactions-move-stock-dropdown-item">
                        <div class="truncate">{{ dataItem.inventoryNumber }}</div>
                        <div class="transactions-move-stock-dropdown-item-description truncate">
                          @if (dataItem.availability !== undefined && dataItem.availability !== null) {
                            <span>| {{ dataItem.availability }}</span>
                          }
                        </div>
                      </div>
                    </ng-template>
                  </kendo-combobox>
                </div>
              </div>
              <div class="transactions-stock-right-checkbox empty-small"></div>
            </div>
          </div>
          <div class="col-12">
            <div class="form-group special_style_formgroup">
              <div class="row">
                <div class="col-2"><label class="control-label">Breakdown Quantity</label></div>
                <div class="col-10 transaction-input-fields">
                  <kendo-numerictextbox #breakdown_quantity_input
                    format="{{ quantityFormat }}"
                    [formControl]="_breakdownQuantity"
                    [spinners]="false"
                    [placeholder]="'Breakdown Quantity'"
                    class="bordered newFormControlWidth" [min]="0">
                  </kendo-numerictextbox>
                </div>
              </div>
              <div class="transactions-stock-right-checkbox empty-small"></div>
            </div>
          </div>
          <div class="col-12">
            <div class="form-group special_style_formgroup">
              <div class="row">
                <div class="col-2"><label class="control-label">Breakdown Location</label></div>
                <div class="col-10 transaction-input-fields">
                  <kendo-combobox #kendo_combo_breakdown_location
                    [data]="_locationsFiltered"
                    [filterable]="true"
                    (filterChange)="_handleLocationsFilter($event)"
                    [suggest]="true"
                    [placeholder]="'Choose a Location'"
                    [textField]="'code'"
                    [valueField]="'id'"
                    [formControl]="_selectedLocation"
                    class="bordered newFormControlWidth" required>
                  </kendo-combobox>
                  <a class="cursor-pointer" (click)="_openForm('locations')">
                    <img class="searchIcon" [src]="'/assets/menu/'+ _theme +'/add-new-icon_grid.svg'">
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="form-group special_style_formgroup">
              <div class="row">
                <div class="col-2"><label class="control-label">Notes</label></div>
                <div class="col-10 transaction-input-fields">
                  <input type="text" [formControl]="_notes" class="k-textbox writebox newFormControlWidth" placeholder="Notes.." />
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
  <div class="col-12 col-lg-6 small-pad-left">
    <div [ngClass]="isScanInventoryExpanded == true ? 'transactionWidget' : 'transactionWidget-collapse'">
      <div class="row">

        <div class="col-12 sectionheader">
          <span class="titleStandardStyle">Scan Inventory ID#</span>
          <span [ngClass]="isScanInventoryExpanded == true ? 'k-icon k-i-sort-asc-sm' :  'k-icon k-i-sort-desc-sm'"
          class="float-right pointer-click" (click)="ExpandCollapseScanInventoryWidget(isScanInventoryExpanded)"></span>
        </div>

        @if (isScanInventoryExpanded) {
          <div class="col-12 margin-top-10">
            <div class="form-group special_style_formgroup display-flex">
              <div class="row flex-1">
                <div class="col-2">
                  <label class="control-label">Stock Item#</label>
                </div>
                <div class="col-10 transaction-input-fields">
                  <kendo-combobox #kendo_combo_stock_item
                    [data]="_itemsFiltered"
                    [filterable]="true"
                    (filterChange)="_handleItemsFilter($event)"
                    (valueChange)="_handleItemsChange($event)"
                    [suggest]="true"
                    [placeholder]="'Stock Item#'"
                    [textField]="'number'"
                    [valueField]="'id'"
                    [formControl]="_selectedStockItem"
                    class="bordered newFormControlWidth" required>
                  </kendo-combobox>
                  <span class="asap-input-icon">
                    <img class="addIcon" (click)="_selectStocksHandler()" [src]="'/assets/menu/'+ _theme +'/multi-select-icon.svg'">
                  </span>
                </div>
              </div>
              <div class="transactions-stock-right-checkbox empty"></div>
            </div>
          </div>
          <div class="col-12">
            <div class="form-group special_style_formgroup display-flex">
              <div class="row flex-1">
                <div class="col-2">
                  <label class="control-label">
                    Inventory ID#
                  </label>
                </div>
                <div class="col-10 transaction-input-fields">
                  <input type="text" class="k-textbox writebox newFormControlWidth"
                    [placeholder]="'Inventory ID#'" [formControl]="_inventoryCode"
                    (keyup.enter)="_quantitySubmited()" (keydown.Tab)="_quantitySubmited()"
                    required />
                    <a class="cursor-pointer"
                      (click)="_generateBarcodeClick()">
                      <img class="searchIcon"
                        [src]="'/assets/menu/'+ _theme +'/auto-generate-icon.svg'">
                      </a>
                    </div>
                  </div>
                  <div class="transactions-stock-right-checkbox">
                    <input type="checkbox" class="k-checkbox" [formControl]="_autoCodeGeneration"
                      kendoCheckBox />
                      <div class="transactions-stock-right-checkbox-text">Auto Generate</div>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group special_style_formgroup display-flex">
                    <div class="row flex-1">
                      <div class="col-2">
                        <label class="control-label"
                          [class.disabled]="_itemType === 'standard' || _itemType === 'non-inventory'">Expiration Date</label>
                      </div>
                      <div class="col-10 transaction-input-fields">
                        <kendo-datetimepicker class="k-datepicker newFormControlWidth" [formControl]="_expirationDate"
                          [min]="_minDate"
                          [class.disabled]="_itemType === 'standard' || _itemType === 'non-inventory'"
                          placeholder="Choose Date" (valueChange)="_dateChanged($event)"
                          [format]="_datePickerFormat">
                        </kendo-datetimepicker>
                      </div>
                    </div>
                    <div class="transactions-stock-right-checkbox empty"></div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group special_style_formgroup display-flex">
                    <div class="row flex-1">
                      <div class="col-2"><label class="control-label">Receive Quantity</label></div>
                      <div class="col-10 transaction-input-fields">
                        <kendo-numerictextbox #quantity_input class="bordered newFormControlWidth" [min]="0" format="{{ quantityFormat }}"
                          [spinners]="false" [placeholder]="'Receive Quantity'"
                        [formControl]="_quantity" (keyup.enter)="_quantitySubmited()" (keydown.Tab)="_quantitySubmited()"></kendo-numerictextbox>
                      </div>
                    </div>
                    <div class="transactions-stock-right-checkbox">
                      <input type="checkbox" class="k-checkbox" [formControl]="_defaultQuantity"
                        kendoCheckBox />
                        <div class="transactions-stock-right-checkbox-text">Set as Default</div>
                      </div>
                    </div>
                    <div class="section-separator"></div>
                  </div>
                  <div class="col-12">
                    <div class="form-group special_style_formgroup display-flex">
                      <div class="row flex-1">
                        <div class="col-2">
                          <label class="control-label">
                            Attached Document
                          </label>
                        </div>
                        <div class="col-10 transaction-input-fields">
                          <input type="text" class="k-textbox writebox" placeholder="Upload file.." />
                        </div>
                      </div>
                      <div class="transactions-stock-right-checkbox empty"
                        [class.notempty]="_settingsPrintReceipt && _settingsPrintReceipt.enabled">
                        @if (_settingsPrintReceipt && _settingsPrintReceipt.enabled) {
                          <input type="checkbox" class="k-checkbox newFormControlWidth" kendoCheckBox [formControl]="_printReceipt"
                            />
                        }
                        @if (_settingsPrintReceipt && _settingsPrintReceipt.enabled) {
                          <div class="transactions-stock-right-checkbox-text"
                          >Print Receipt</div>
                        }
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="transactionWidget with-grid numericboxtab">
              <div class="flex-space-between transaction-grid-header-wrapper">
                <p class="titleStandardStyle">Selected Items</p>
                <div class="transaction-grid-top-actions">
                  <div class="transaction-grid-top-actions-radio">
                    <input type="radio" id="new-to-old-items" name="transaction-duration" value="new"
                      [formControl]="_sortingSelected" kendoRadioButton />
                      <label class="k-radio-label" [for]="'new-to-old-items'">Newest To Oldest</label>
                    </div>
                    <div class="transaction-grid-top-actions-radio">
                      <input type="radio" id="old-to-new-items" name="transaction-duration" value="old"
                        [formControl]="_sortingSelected" kendoRadioButton />
                        <label class="k-radio-label" [for]="'old-to-new-items'">Oldest To Newest</label>
                      </div>
                    </div>
                  </div>

                  <kendo-grid [data]="_inventoryGridData" [scrollable]="'none'" class="transaction-grid"
                    (remove)="_removeHandler($event)">

                    <kendo-grid-column field="itemNumber" title="Stock Item #">
                    </kendo-grid-column>

                    <kendo-grid-column field="description" title="Stock Description">
                    </kendo-grid-column>

                    <kendo-grid-column field="quantity" title="Receive Quantity">
                      <ng-template kendoGridCellTemplate let-dataItem>
                        <kendo-numerictextbox class="transaction-grid-quantity" [value]="dataItem.quantity"
                          format="{{ quantityFormat }}" (valueChange)="_onQuantityChange($event, dataItem)" [min]="0"
                          [autoCorrect]="true">
                        </kendo-numerictextbox>
                      </ng-template>
                    </kendo-grid-column>

                    <kendo-grid-column field="uom" title="Receive U/M">
                    </kendo-grid-column>

                    <kendo-grid-column field="inventoryCode" title="Inventory ID#">
                    </kendo-grid-column>

                    <kendo-grid-column field="expirationDate" title="Expiration Date">
                      <ng-template kendoGridCellTemplate let-dataItem>
                        <span>{{ dataItem.expirationDate ? (dataItem.expirationDate | date: 'MM/dd/yyyy') : '' }}</span>
                      </ng-template>
                    </kendo-grid-column>

                    <kendo-grid-column field="unitCost" title="Unit Cost">
                      <ng-template kendoGridCellTemplate let-dataItem>
                        <span>{{ dataItem.unitCost != null ? (dataItem.unitCost | number: _costFormat) : '' }}</span>
                      </ng-template>
                    </kendo-grid-column>

                    <kendo-grid-command-column title="Action">
                      <ng-template kendoGridCellTemplate>
                        <div kendoGridRemoveCommand class="asap-grid-remove">
                          <div class="asap-grid-remove-icon">
                            <img src="/assets/menu/enterprise/remove-icon.svg" />
                          </div>
                          <div class="asap-grid-remove-text">
                            Delete
                          </div>
                        </div>
                      </ng-template>
                    </kendo-grid-command-column>
                  </kendo-grid>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                @if (_invalidForm) {
                  <asap-forms-validation-summary [form]="_form" [page]="'breakdown'">
                  </asap-forms-validation-summary>
                }
              </div>
            </div>
          </form>
          @if (false) {
            <kendo-window>
              <div class="row zeromarginRow">
                <div class="col-12 col-lg-6 zeroPaddingColumn">
                  <div class="row zeromarginRow">
                    <div class="col-12  margin-top-10 zeroPaddingColumn">
                      <div class="form-group special_style_formgroup">
                        <div class="row zeromarginRow">
                          <div class="col-2">
                            <label class="control-label">
                              Receive
                              Receipt
                            </label>
                          </div>
                          <div class="col-10 transaction-receive-input-fields">
                            <kendo-combobox #kendo_combo_Receipt_Report [data]="receiveReports" [suggest]="true"
                              class="bordered newFormControlWidth" [textField]="'name'" [valueField]="'id'"
                              placeholder="Select Receive Print Receipt">
                            </kendo-combobox>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 margin-top-10 zeroPaddingColumn">
                  <button kendoButton class="steps_buttons_class" (click)="_printReceiptReport()">
                    <img class="backimage"
                      [src]="'/assets/menu/'+ _theme +'/close-schedule-report-icon-green.svg'" />
                      <span>Print</span>
                    </button>
                  </div>
                </div>
              </kendo-window>
            }
